import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function PricingCards() {
  const [selectedPack, setSelectedPack] = useState<1 | 2>(2);
  const handleCtaClick = () => {
    if (selectedPack === 1) {
      // URL de pago Megapack 1 (14,97€)
      window.location.href = 'https://checkout.cherubagency.com/cart/56679269990724:1';
    } else {
      // URL de pago Megapack Completo (23,97€)
      window.location.href = 'https://checkout.cherubagency.com/cart/56679363772740:1';
    }
  };
  return <section id="pricing" className="bg-[#0A1628] py-12 px-6" data-id="element-281">
      <div className="max-w-3xl mx-auto" data-id="element-282">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} style={{
        willChange: 'transform, opacity'
      }} className="text-center mb-6" data-id="element-283">
          <h2 className="font-display font-bold text-[32px] md:text-[42px]" data-id="element-284">
            <span className="text-[#FFFFFF]" data-id="element-285">ELIGE TU</span>{' '}
            <span className="text-[#C9A84C]" data-id="element-286">MEGAPACK</span>
          </h2>
        </motion.div>

        <div className="flex flex-col gap-[8px]" data-id="element-287">
          {/* TARJETA OPCIÓN 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} style={{
          willChange: 'transform, opacity'
        }} onClick={() => setSelectedPack(1)} role="radio" aria-checked={selectedPack === 1} tabIndex={0} onKeyDown={e => e.key === 'Enter' && setSelectedPack(1)} aria-label="Seleccionar MegaPack 1 por 14,97 euros" className={`relative p-[16px] rounded-[16px] cursor-pointer transition-all duration-300 flex items-center gap-4 md:gap-6 w-full ${selectedPack === 1 ? 'bg-[#0F1E35] border-2 border-[#C9A84C] shadow-[0_0_20px_rgba(201,168,76,0.25)]' : 'bg-[#0F1E35] border-[1.5px] border-[#2A3A50] shadow-none'}`} data-id="element-288">
            {/* Círculo de selección */}
            <div className={`w-[24px] h-[24px] rounded-full flex-shrink-0 flex items-center justify-center transition-colors ${selectedPack === 1 ? 'border-2 border-[#C9A84C] bg-[#C9A84C]' : 'border-2 border-[#AAAAAA] bg-transparent'}`} data-id="element-289">
              {selectedPack === 1 && <div className="w-[10px] h-[10px] rounded-full bg-[#0A1628]" data-id="element-290" />}
            </div>

            {/* Contenido de la tarjeta */}
            <div className="flex-grow flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-291">
              <div data-id="element-292">
                <h3 className="text-[#FFFFFF] text-[22px] font-bold leading-tight mb-0.5 flex items-center gap-2" data-id="element-293">
                  <span className="text-[28px] leading-none" data-id="element-294">📘</span> MEGAPACK
                  1
                </h3>
                <p className="text-[#FFFFFF] text-[18px] font-bold leading-tight mb-1" data-id="element-295">
                  TDAH: GUÍA PARA SALVAR A TU HIJO
                </p>
                <p className="text-[#AAAAAA] text-[15px] font-normal mb-1.5" data-id="element-296">
                  5 Tomos + 3 Bonos
                </p>
                <p className="text-[#C9A84C] text-[14px] font-bold" data-id="element-297">
                  Ideal para: Recuperar la calma en casa desde esta semana
                </p>
              </div>

              <div className="flex flex-col items-start md:items-end mt-2 md:mt-0" data-id="element-298">
                <span className="text-[#666666] text-[16px] line-through mb-0.5" data-id="element-299">
                  75,76€
                </span>
                <div className="flex items-baseline" data-id="element-300">
                  <span className="text-[#FFFFFF] text-[28px] md:text-[36px] font-extrabold leading-none" data-id="element-301">
                    14,97
                  </span>
                  <span className="text-[#FFFFFF] text-[22px] font-bold ml-1" data-id="element-302">
                    €
                  </span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* TARJETA OPCIÓN 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} style={{
          willChange: 'transform, opacity'
        }} onClick={() => setSelectedPack(2)} role="radio" aria-checked={selectedPack === 2} tabIndex={0} onKeyDown={e => e.key === 'Enter' && setSelectedPack(2)} aria-label="Seleccionar MegaPack Completo por 23,97 euros" className={`relative p-[16px] rounded-[16px] cursor-pointer transition-all duration-300 flex items-center gap-4 md:gap-6 w-full mt-2 md:mt-0 ${selectedPack === 2 ? 'bg-[#0F1E35] border-2 border-[#C9A84C] shadow-[0_0_20px_rgba(201,168,76,0.25)]' : 'bg-[#0F1E35] border-[1.5px] border-[#2A3A50] shadow-none'}`} data-id="element-303">
            {/* Badge */}
            <div className="absolute -top-3 right-4 md:right-6 bg-[#C9A84C] text-[#0A1628] font-bold text-[12px] px-[12px] py-[4px] rounded-[20px] font-body" data-id="element-304">
              ⭐ MÁS ELEGIDO
            </div>

            {/* Círculo de selección */}
            <div className={`w-[24px] h-[24px] rounded-full flex-shrink-0 flex items-center justify-center transition-colors ${selectedPack === 2 ? 'border-2 border-[#C9A84C] bg-[#C9A84C]' : 'border-2 border-[#AAAAAA] bg-transparent'}`} data-id="element-305">
              {selectedPack === 2 && <div className="w-[10px] h-[10px] rounded-full bg-[#0A1628]" data-id="element-306" />}
            </div>

            {/* Contenido de la tarjeta */}
            <div className="flex-grow flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-307">
              <div data-id="element-308">
                <h3 className="text-[#FFFFFF] text-[22px] font-bold leading-tight mb-0.5 flex items-center gap-2" data-id="element-309">
                  <span className="text-[28px] leading-none" data-id="element-310">🏆</span> MEGAPACK
                  COMPLETO
                </h3>
                <p className="text-[#FFFFFF] text-[18px] font-bold leading-tight mb-1" data-id="element-311">
                  TDAH: GUÍA PARA SALVAR A TU HIJO
                  <br className="hidden md:block" data-id="element-312" />+ EL CAMINO AL ÉXITO
                </p>
                <p className="text-[#AAAAAA] text-[15px] font-normal mb-1.5" data-id="element-313">
                  10 Tomos + 7 Bonos
                </p>
                <p className="text-[#C9A84C] text-[14px] font-bold" data-id="element-314">
                  Ideal para: Resolver el presente Y asegurar
                  <br className="hidden md:block" data-id="element-315" />
                  el futuro de tu hijo
                </p>
              </div>

              <div className="flex flex-col items-start md:items-end mt-2 md:mt-0" data-id="element-316">
                <span className="text-[#666666] text-[16px] line-through mb-0.5" data-id="element-317">
                  157,49€
                </span>
                <div className="flex items-baseline" data-id="element-318">
                  <span className="text-[#C9A84C] text-[28px] md:text-[36px] font-extrabold leading-none" data-id="element-319">
                    23,97
                  </span>
                  <span className="text-[#C9A84C] text-[22px] font-bold ml-1" data-id="element-320">
                    €
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* BOTÓN CTA DINÁMICO */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} style={{
        willChange: 'transform, opacity'
      }} className="mt-4" data-id="element-321">
          <button onClick={handleCtaClick} aria-label={selectedPack === 1 ? 'Comprar MegaPack 1 ahora' : 'Comprar Sistema Completo ahora'} className="w-full min-h-[56px] bg-[#C9A84C] hover:bg-[#F0D080] text-[#0A1628] font-bold text-[18px] uppercase rounded-[10px] py-[12px] px-[36px] shadow-[0_4px_20px_rgba(201,168,76,0.4)] transition-colors font-body" data-id="element-322">
            {selectedPack === 1 ? '→ QUIERO EL MEGAPACK 1' : '→ QUIERO EL SISTEMA COMPLETO'}
          </button>

          {/* BADGES DE CONFIANZA */}
          <div className="flex flex-col md:flex-row justify-center items-center gap-[10px] mt-3 text-[#AAAAAA] text-[13px] font-body" data-id="element-323">
            <span data-id="element-324">🔒 Pago 100% seguro</span>
            <span className="hidden md:inline" data-id="element-325"></span>
            <span data-id="element-326">⚡ Acceso en 5 minutos</span>
            <span className="hidden md:inline" data-id="element-327"></span>
            <span data-id="element-328">🛡️ Garantía 7 días</span>
          </div>
        </motion.div>
      </div>
    </section>;
}